'use strict';

import React, {Component} from "react";
import {observer} from "mobx-react";

import Alert from 'react-bootstrap/Alert';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import feedbackMessagesStore from "./FeedbackMessagesStore";
import Level from "./FeedbackMessagesLevel";

/**
 * A global message map display component.
 */
class FeedbackMessages extends Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.store = feedbackMessagesStore;

        // Bind this to click handlers.
        this.handleDialogClose = this.handleDialogClose.bind(this);
    }

    hasError() {
        return this.store.messageMap.error.length > 0
    }

    hasInfo() {
        return this.store.messageMap.info.length > 0
    }

    hasWarning() {
        return this.store.messageMap.warning.length > 0
    }

    hasSuccess() {
        return this.store.messageMap.success.length > 0
    }

    hasMessages() {
        if (! this.store.messageMap) {
            return false;
        }
        return this.hasError() || this.hasInfo() || this.hasWarning() || this.hasSuccess();
    }

    handleDialogClose(level) {
        this.store.removeMessages(level);
    }

    /**
     * Creates a messages for the given level.
     */
    makeMessageBox(level) {
        let messageStyle = level;
        if (messageStyle === "error") {
            messageStyle = "danger";
        }

        let messages = this.store.messageMap[level.toLowerCase()].map((message, index) => {
            return (
                <li key={index}>{message.text}</li>
            );
        });

        return(
           <Alert variant={messageStyle} dismissible onClose={() => this.handleDialogClose(level)}>
                <ul className="list-unstyled mb-0">{messages}</ul>
           </Alert>
        );
    }

    render() {
        if (! this.hasMessages()) {
            return false;
        }

        let success, info, warning, error;

        if (this.hasSuccess()) {
            success = this.makeMessageBox(Level.SUCCESS);
        }

        if (this.hasInfo()) {
            info = this.makeMessageBox(Level.INFO);
        }

        if (this.hasWarning()) {
            warning = this.makeMessageBox(Level.WARNING);
        }

        if (this.hasError()) {
            error = this.makeMessageBox(Level.ERROR);
        }

        return (
            <div className="feedback-messages-dialog" role="alert" aria-live="assertive">
                {success}
                {info}
                {warning}
                {error}
            </div>
        );
    }
}

export default observer(FeedbackMessages);
